import { styled } from '../../styles';
import { Chip } from '../Chip';
import { Typography } from '../Typography';

export const SelectHighlightsContainer = styled.div(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  padding: theme.spacing(0, 2, 2),
  gap: theme.spacing(2),
}));

export const SelectHighlightsTitle = styled(Typography)(({ theme }) => ({
  color: theme.palette.text3,
  marginTop: theme.spacing(2),
}));

export const SelectHighlightsList = styled.div(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(2),
  justifyContent: 'flex-start',
  flexWrap: 'wrap',
  width: '100%',
}));

export const SelectHighlightsCoin = styled(Chip)(({ theme }) => ({
  gap: theme.spacing(3),
  background: theme.palette.surface3,
}));
